import { ShippingFeeLabelTextHelper } from '../labelTextHelper/ShippingFeeLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

export const ShippingFeeHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: ShippingFeeLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: ShippingFeeLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            { text: ShippingFeeLabelTextHelper.getLabelText.shippingFeeAmount, value: 'shippingFeeAmount' }
        ];
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems()];
    },

    getImportFields() {
        return this.getHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getHeaderItems();
    }
};
